'use client'

import { cloneElement, HTMLAttributes, isValidElement, PropsWithChildren, ReactElement, Ref, useEffect } from 'react'
import { useExposureObserver, useTrackClick, useTrackNavigate } from '../../hooks'
import { TrackerProvider } from './tracker-context'
import { TrackPageSection } from '../constant'
import { TrackerConfig, TrackerProps } from '@avia/tracker'

export const TrackPageExposure = ({ children, config }: PropsWithChildren<TrackerProps>) => {
  const data = { sectionName: TrackPageSection, ...config }

  useEffect(() => {
    const key = JSON.stringify(data)
    tracker.exposure(data, key)
    return () => {
      tracker.exposure({}, key, false)
    }
  }, [])

  return <TrackerProvider config={data}>{children}</TrackerProvider>
}

type TrackExposureProps = {
  children: ReactElement // 必须是单一元素
  withClick?: boolean | TrackerConfig
  withNavigate?: boolean | TrackerConfig
  disabledExposure?: boolean
} & Partial<TrackerProps>

export const TrackExposure = ({ children, withClick, withNavigate, config, disabledExposure }: TrackExposureProps) => {
  const observe = useExposureObserver(config)
  const click = useTrackClick(config)
  const navigate = useTrackNavigate(config)

  if (!isValidElement(children)) {
    console.warn('TrackShow expects a single React element as a child.')
    return null
  }

  return cloneElement(children, {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    ref: (node: HTMLElement) => {
      if (!disabledExposure) {
        observe(node, config)
      }
      const originalRef = (children as ReactElement<{ ref?: Ref<HTMLElement> }>).props.ref
      if (typeof originalRef === 'function') {
        originalRef(node)
      } else if (originalRef) {
        originalRef.current = node
      }
    },
    onClick: (e: unknown) => {
      const { onClick } = (children as ReactElement<HTMLAttributes<HTMLElement>>).props
      if (withClick || withNavigate) {
        const clickConfig = withClick || withNavigate!
        click(typeof clickConfig === 'boolean' ? undefined : clickConfig)
      }
      if (withNavigate) {
        navigate(typeof withNavigate === 'boolean' ? undefined : withNavigate)
      }
      if (onClick) {
        // @ts-expect-error IGNORE
        onClick(e)
      }
    },
  })
}
